import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRulesBreaking: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULES_BREAKING,
	},
	getRuleBreaking: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULE_BREAKING,
	}
}
